// core version + navigation, pagination modules:
// import Swiper, {Pagination, EffectFade, Autoplay, A11y} from 'swiper';

export default {
  finalize() {
    /* global flatpickr, rangePlugin, locale */

    window.booking = window.booking || {};
    const bookingForm = document.getElementById('booking-form-home');
    const DEBUG_BOOKING = false;
    const logDebug = (event, payload) => {
      if (!DEBUG_BOOKING) return;
      console.log('[booking-debug]', event, payload || '');
    };

    const getBookingValues = () => {
      const hotelCodeEl = document.getElementById('hotel_code');
      const adultsEl = document.getElementById('adults');
      const childrenEl = document.getElementById('children');
      const childrenageEls = document.getElementsByName('childrenage[]');

      return {
        hotel_code: hotelCodeEl ? parseInt(hotelCodeEl.value) : null,
        datePicker: {
          checkin: datePicker.selectedDates[0] ? datePicker.selectedDates[0].yyyymmdd() : null,
          checkout: datePicker.selectedDates[1] ? datePicker.selectedDates[1].yyyymmdd() : null,
        },
        adults: adultsEl ? parseInt(adultsEl.value) : null,
        children: childrenEl ? parseInt(childrenEl.value) : null,
        childrenage: Array.from(childrenageEls).map(input => input.value),
      };
    };

    const buildBookingUrl = ({requireDates = false} = {}) => {
      const values = getBookingValues();
      const hotelCode = values.hotel_code || 0;
      const checkin = values.datePicker.checkin;
      const checkout = values.datePicker.checkout;
      const adults = values.adults || 0;
      const children = values.children || 0;
      const childrenage = values.childrenage || [];

      if (requireDates && (!checkin || !checkout)) {
        logDebug('buildBookingUrl:missing-dates-required', {values});
        return null;
      }

      if (!checkin || !checkout) {
        logDebug('buildBookingUrl:missing-dates-fallback', {values, fallback: '/'});
        return '/';
      }

      const channelCode = hotelCode > 0 && locale.hotel_data[hotelCode] ?
        locale.hotel_data[hotelCode].codice_canale : '1244';

      let ages = '';
      if (childrenage.length > 0) {
        ages = '&ages=' + childrenage.join(',');
      }

      let baseErmesUrl = locale.ermes_base_url;

      if (hotelCode > 0) {
        baseErmesUrl = baseErmesUrl.replace('/#', '/#/hotel/' + hotelCode).replace('/?', '/rooms/?');
      }

      if (channelCode > 0) {
        baseErmesUrl = baseErmesUrl.replace('CODICECANALE', channelCode);
      }

      const url = baseErmesUrl + 'arrival=' + checkin + '&departure=' + checkout + '&adults=' + adults + '&childs=' + children + ages;
      logDebug('buildBookingUrl:computed', {values, url});
      return url;
    };

    window.booking.urlFormUpdated = function (url) {
      if (!bookingForm || typeof url !== 'string' || !url.length) {
        logDebug('urlFormUpdated:skipped', {
          hasForm: !!bookingForm,
          urlType: typeof url,
          urlLength: typeof url === 'string' ? url.length : null,
        });
        return;
      }
      bookingForm.setAttribute('action', url);
      logDebug('urlFormUpdated:applied', {action: bookingForm.getAttribute('action')});
    };

    window.booking.updateUrlForm = function () {
      const url = buildBookingUrl();
      logDebug('updateUrlForm:called', {url});
      window.booking.urlFormUpdated(url);
      return url;
    };

    const existingOnFieldTouched = window.booking.onFieldTouched;
    window.booking.onFieldTouched = function (detail) {
      logDebug('onFieldTouched', detail);
      window.booking.updateUrlForm();
      if (typeof existingOnFieldTouched === 'function') {
        existingOnFieldTouched(detail);
      }
    };

    const notifyBookingFieldTouched = (fieldName, triggerEvent) => {
      const detail = {
        field: fieldName,
        trigger: triggerEvent,
        values: getBookingValues(),
      };
      logDebug('notifyBookingFieldTouched', detail);

      if (typeof window.booking.onFieldTouched === 'function') {
        window.booking.onFieldTouched(detail);
      }

      document.dispatchEvent(new CustomEvent('booking:field-touched', {detail}));
    };

    let datePicker;
    datePicker = flatpickr('#checkin', {
      mode: 'range',
      minDate: 'today',
      locale: locale.current,
      formatDate: dateObj => dateObj.toLocaleDateString(locale.current),
      onChange: () => {
        logDebug('datePicker:onChange', {
          selectedDates: datePicker.selectedDates.map(date => date.yyyymmdd()),
        });
        notifyBookingFieldTouched('datePicker', 'change');
      },
      'plugins': [new rangePlugin({input: '#checkout'})],
    });

    if (bookingForm) {
      const isTrackedField = element => {
        if (!element) {
          return false;
        }

        return element.id === 'hotel_code' ||
          element.id === 'adults' ||
          element.id === 'children' ||
          element.name === 'childrenage[]';
      };

      const getFieldName = element => {
        if (element.id === 'hotel_code') {
          return 'hotel_code';
        }
        if (element.id === 'adults') {
          return 'adults';
        }
        if (element.id === 'children') {
          return 'children';
        }
        if (element.name === 'childrenage[]') {
          return 'childrenage';
        }

        return element.name || element.id || 'unknown';
      };

      const handleTrackedInteraction = eventName => event => {
        const target = event.target;
        if (!isTrackedField(target)) {
          return;
        }
        logDebug('trackedFieldInteraction', {
          eventName,
          field: getFieldName(target),
          value: target.value,
        });

        notifyBookingFieldTouched(getFieldName(target), eventName);
      };

      bookingForm.addEventListener('change', handleTrackedInteraction('change'));
      bookingForm.addEventListener('input', handleTrackedInteraction('input'));
      bookingForm.addEventListener('submit', event => {
        const hasCheckin = datePicker.selectedDates[0] !== undefined;
        const hasCheckout = datePicker.selectedDates[1] !== undefined;

        if (!hasCheckin || !hasCheckout) {
          event.preventDefault();
          logDebug('submit:prevented-missing-dates', {
            hasCheckin,
            hasCheckout,
            selectedDates: datePicker.selectedDates.length,
          });
          alert(locale.please_select_dates);
          return;
        }

        // Keep native submit, but avoid appending form fields as duplicate query params.
        const actionUrl = window.booking.updateUrlForm();
        logDebug('submit:native', {actionUrl});
        const namedFields = bookingForm.querySelectorAll('input[name], select[name], textarea[name], button[name]');
        namedFields.forEach(field => {
          field.disabled = true;
        });
      });
    }

    window.booking.updateUrlForm();

    window.booking.submit = function () {

      if (datePicker.selectedDates[0] === undefined || datePicker.selectedDates[1] === undefined) {
        logDebug('submit:blocked-missing-dates', {selectedDates: datePicker.selectedDates.length});
        alert(locale.please_select_dates);
        return;
      }

      const urlToGo = buildBookingUrl({requireDates: true});
      logDebug('submit:url-ready', {urlToGo});
      // debugger;
      // window.open(urlToGo);
      console.log('urlToGo:' + urlToGo); 
    }
  },
};
